import React, { useContext } from 'react';
import Head from 'next/head';
import { v4 as uuid } from 'uuid';
import { ServerContext } from '../../context/ServerContext';
import { renderMetaItemFromType } from '../../contentModels/PageMeta/utils/renderMetaItemFromType';
export const HeadTags = ({
  cssOverride,
  pageMetaModel
}) => {
  const {
    page
  } = useContext(ServerContext);

  if (!page) {
    return null;
  }

  const schemaObjectItems = pageMetaModel.filledSchema.filter(schema => schema.type === 'object');
  const schemaLdJsonItems = pageMetaModel.filledSchema.filter(schema => schema.type === 'ld-json');
  const schemaMetaTags = schemaObjectItems.map(schema => renderMetaItemFromType(schema.data, {
    page
  })).reduce((acc, arr) => [...acc, ...arr], []); // flatten arrays

  const jsonLdTags = schemaLdJsonItems.map(schema => {
    return /*#__PURE__*/React.createElement("script", {
      key: uuid(),
      type: "application/ld+json"
    }, JSON.stringify(schema.data));
  });
  const cssStyleTags = cssOverride && cssOverride.css ? /*#__PURE__*/React.createElement("style", {
    id: "cssOverride",
    key: "cssOverride",
    type: "text/css"
  }, cssOverride.css) : null;
  const {
    baseUrl,
    siteName,
    path
  } = page;
  const baseSetTags = [/*#__PURE__*/React.createElement("meta", {
    content: "en_US",
    key: "og:locale",
    property: "og:locale"
  }), /*#__PURE__*/React.createElement("meta", {
    content: `${siteName || 'GoodRx'}`,
    key: "og:site_name",
    property: "og:site_name"
  }), /*#__PURE__*/React.createElement("meta", {
    content: "website",
    key: "og:type",
    property: "og:type"
  }), /*#__PURE__*/React.createElement("meta", {
    content: `${baseUrl}/${path === null || path === void 0 ? void 0 : path.substring(1)}`,
    key: "og:url",
    property: "og:url"
  })];
  const {
    url: imageUrl,
    width: imageWidth,
    height: imageHeight
  } = pageMetaModel.image || {};
  const imageTags = pageMetaModel.image ? [/*#__PURE__*/React.createElement("meta", {
    content: `${imageUrl}`,
    key: "og:image",
    property: "og:image"
  }), /*#__PURE__*/React.createElement("meta", {
    content: `${imageWidth}`,
    key: "og:image:width",
    property: "og:image:width"
  }), /*#__PURE__*/React.createElement("meta", {
    content: `${imageHeight}`,
    key: "og:image:height",
    property: "og:image:height"
  })] : [];
  return /*#__PURE__*/React.createElement(Head, null, [...jsonLdTags, ...schemaMetaTags, ...baseSetTags, ...imageTags, cssStyleTags].filter(Boolean));
};